import TermsRedirectPage from './TermsRedirectPage';

export default TermsRedirectPage;
